import { render, staticRenderFns } from "./FieldConfig.vue?vue&type=template&id=5b83cfa4&scoped=true"
import script from "./FieldConfig.vue?vue&type=script&lang=js"
export * from "./FieldConfig.vue?vue&type=script&lang=js"
import style0 from "./FieldConfig.vue?vue&type=style&index=0&id=5b83cfa4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83cfa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b83cfa4')) {
      api.createRecord('5b83cfa4', component.options)
    } else {
      api.reload('5b83cfa4', component.options)
    }
    module.hot.accept("./FieldConfig.vue?vue&type=template&id=5b83cfa4&scoped=true", function () {
      api.rerender('5b83cfa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/fieldConfig/FieldConfig.vue"
export default component.exports